import { render, staticRenderFns } from "./materialBatchConfig.vue?vue&type=template&id=0cb0bca0&scoped=true"
import script from "./materialBatchConfig.vue?vue&type=script&lang=js"
export * from "./materialBatchConfig.vue?vue&type=script&lang=js"
import style0 from "./materialBatchConfig.vue?vue&type=style&index=0&id=0cb0bca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb0bca0",
  null
  
)

export default component.exports